import { ErrorContainer, ErrorTitle, ErrorLink } from "./ErrorElements";

const Error = () => {
  return (
    <ErrorContainer>
      <ErrorTitle>Error 404 / La página no existe.</ErrorTitle>
      <ErrorLink to="/">Volver a Inicio</ErrorLink>
    </ErrorContainer>
  );
};

export default Error;
